import React from "react";
import "./Footer.css";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";

const Footer = () => {
  return (
    <section id="footer">
      <div className="footer__socials">
        <a
          href="https://www.linkedin.com/in/miguel-disu-lord-92543b134/"
          target="_blank"
          rel="noreferrer"
        >
          <BsLinkedin />
        </a>
        <a href="https://github.com/md-l" target="_blank" rel="noreferrer">
          <FaGithub />
        </a>
      </div>
    </section>
  );
};

export default Footer;
